import { Component, OnInit } from '@angular/core'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import { EVENT_NAMES } from '../../utils/events'
import { ActivatedRoute, Router } from '@angular/router'
import { SubmitOtpResponse } from '../../interfaces/submit-otp-response'

@Component({
  selector: 'app-otp-layout',
  templateUrl: './otp-layout.component.html',
  styleUrls: ['./otp-layout.component.scss'],
})
export class OtpLayoutComponent implements OnInit {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })
  constructor(private router: Router, private route: ActivatedRoute) {}

  private handleOnExit = () => {
    const flow = this.router.url.split('/')[1]
    const process = this.router.url.split('/')[2]
    this.router.navigate([flow, process], { replaceUrl: true })
  }

  private handleOnSubmitOtp = (event: Event) => {
    const { detail } = event as CustomEvent<SubmitOtpResponse>
    if (detail?.error?.code === 409 || detail?.data?.accountNumber) this.handleNavigateToSummary()
  }

  private handleNavigateToSummary = () => {
    this.router.navigate(['..', 'exito'], { relativeTo: this.route, replaceUrl: true })
  }

  ngOnInit(): void {
    this.storage.set(EVENT_NAMES.otpConfig, { config: 'config' })
    window.addEventListener(EVENT_NAMES.otpOnBack, this.handleOnExit)
    window.addEventListener(EVENT_NAMES.otpOnSubmit, this.handleOnSubmitOtp)
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.otpOnBack, this.handleOnExit)
    window.removeEventListener(EVENT_NAMES.otpOnSubmit, this.handleOnSubmitOtp)
  }
}
